import Nullstack from 'nullstack';
export default function IconCarCrane({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-car-crane",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 18v-11h3"
  }), "   ", Nullstack.element("path", {
    d: "M3 17v-5h9"
  }), "   ", Nullstack.element("path", {
    d: "M4 12v-6l18 -3v2"
  }), "   ", Nullstack.element("path", {
    d: "M8 12v-4l-4 -2"
  }), " ");
}